import { API_URL } from "../config";

const API_BASE_URL = API_URL;

// Helper function for handling API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Something went wrong');
  }
  return response.json();
};

// Articles API
export const getArticles = async (page = 1, limit = 10) => {
  const response = await fetch(`${API_BASE_URL}/articles?page=${page}&limit=${limit}&approved=true`);
  return handleResponse(response);
};

export const getArticlesByCategory = async (category, page = 1, limit = 10) => {
  try {
    const response = await fetch(`${API_BASE_URL}/articles/category/${category._id}?page=${page}&limit=${limit}&approved=true`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    console.error("Error fetching articles by category:", error);
    return [];
  }
};

export const getArticlesByCategoryName = async (categoryName, page = 1, limit = 10) => {
  const response = await fetch(`${API_BASE_URL}/articles/category/name/${categoryName}?page=${page}&limit=${limit}&approved=true`);
  return handleResponse(response);
};

export const getArticleBySlug = async (slug) => {
  const response = await fetch(`${API_BASE_URL}/articles/slug/${slug}`);
  return handleResponse(response);
};

export const getFeaturedArticles = async (limit = 5) => {
  const response = await fetch(`${API_BASE_URL}/articles/featured?limit=${limit}&approved=true`);
  return handleResponse(response);
};

export const getRecentArticles = async (limit = 10) => {
  const response = await fetch(`${API_BASE_URL}/articles/recent?limit=${limit}&approved=true`);
  return handleResponse(response);
};

// New function to get all available categories
export const getCategories = async () => {
  // Use the dedicated endpoint for categories
  const response = await fetch(`${API_BASE_URL}/categories`);
  return handleResponse(response);
};

// New function to get category descriptions from the About page
export const getCategoryDescriptions = async () => {
  // Get category descriptions from the backend
  const response = await fetch(`${API_BASE_URL}/categories/descriptions`);
  return handleResponse(response);
};

// New function to submit an article
export const submitArticle = async (articleData) => {
  const response = await fetch(`${API_BASE_URL}/articles`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(articleData)
  });
  return handleResponse(response);
};

// Feedback API
export const submitFeedback = async (feedbackData) => {
  const response = await fetch(`${API_BASE_URL}/feedback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(feedbackData)
  });
  return handleResponse(response);
}; 

// Analytics: preview view
export const recordNewsletterPreviewView = async (newsletterId) => {
  try {
    await fetch(`${API_BASE_URL}/analytics/newsletters/${newsletterId}/preview-view`, { method: 'POST' });
  } catch (_) {}
};

// Analytics: article view
export const recordArticleView = async (articleId) => {
  try {
    await fetch(`${API_BASE_URL}/analytics/articles/${articleId}/view`, { method: 'POST' });
  } catch (_) {}
};

// Reactions API
export const getArticleReactions = async (articleId) => {
  const response = await fetch(`${API_BASE_URL}/articles/${articleId}/reactions`);
  return handleResponse(response);
};

export const postArticleReaction = async (articleId, type, clientId) => {
  const response = await fetch(`${API_BASE_URL}/articles/${articleId}/reactions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, clientId })
  });
  return handleResponse(response);
};